/*  MOBILE STICKY ADD TO BAG
 *
 *  The real .add-to-cart button stays exactly where it is, under the sizes.
 *  .m-satb is a proxy pinned to the bottom of the viewport while that button is
 *  off screen; an IntersectionObserver at threshold 1 hides the proxy the
 *  instant the real button is fully visible, so the hand-off happens at the
 *  same screen position and reads as the button settling into the page.
 *
 *  The proxy is position:fixed, not sticky: a sticky element is clamped to its
 *  containing block (the product form), which starts below the fold on a tall
 *  mobile gallery, so it would not pin at page load.
 *
 *  Above the button the bar carries a compact brand / title / price strip
 *  (.m-satb__info) while the real ones are still below it. A second observer,
 *  rooted at the viewport minus the button row, collapses the strip the moment
 *  the real price block clears the top of that row - i.e. as the real info
 *  scrolls up to where the strip sits - so it reads as the strip docking.
 *
 *  Loaded with defer from layout/theme.liquid, after jQuery and
 *  custom_script_a.js. The bar builds its own markup - it is chrome, not
 *  content, so no Liquid change is needed and the PDP renders exactly as
 *  before if this file fails to load. Styles: assets/m-satb.css.
 */
(function () {
    'use strict';

    function init() {
        var $ = window.jQuery;
        if (!$) { return; }

        if (!$('body').hasClass('template-product')) { return; }
        if (!window.matchMedia('(max-width: 768px)').matches) { return; }
        if (!('IntersectionObserver' in window)) { return; }

        var $realBtn = $('.product-single__form .payment-buttons .add-to-cart').first();
        if (!$realBtn.length) {
            $realBtn = $('.product-single__form button[name="add"]').first();
        }
        if (!$realBtn.length || !$realBtn.is(':visible')) { return; }

        // Built here and appended to <body> so that no transformed or
        // overflow-hidden ancestor can break position:fixed. The label is
        // overwritten by sync() below from the real button.
        var $satb = $(
            '<div class="m-satb" aria-hidden="true">' +
              '<div class="m-satb__info">' +
                '<div class="m-satb__vendor"></div>' +
                '<div class="m-satb__title"></div>' +
                '<div class="m-satb__price"></div>' +
              '</div>' +
              '<button type="button" class="m-satb__btn" data-m-satb-btn>' +
                '<span class="m-satb__label">Add to Bag</span>' +
              '</button>' +
            '</div>'
        ).appendTo('body');

        var $satbBtn = $satb.find('[data-m-satb-btn]');
        var $satbLabel = $satb.find('.m-satb__label');

        // Height of the button row alone - measured before the strip has any
        // content, so it is the fixed band the real info has to clear.
        var btnRowH = Math.round($satb[0].getBoundingClientRect().height);

        var $meta = $realBtn.closest('.product-single__meta');
        if (!$meta.length) { $meta = $('.product-single__meta').first(); }
        var $info = $satb.find('.m-satb__info');

        $info.find('.m-satb__vendor').text($.trim($meta.find('.product-single__vendor').first().text()));
        $info.find('.m-satb__title').text($.trim($meta.find('h1.product-single__title > span').first().text()));

        // Grouped / Grouped-Fits show the combined .full_price; everything
        // else the variant price (+ compare-at and savings when on sale).
        function priceSources() {
            var $full = $meta.find('.full_price .price').filter(':visible').first();
            if ($full.length) { return $full; }
            return $meta.children('[class*="product__price-wrap-"], .product__price, .product__price-savings')
                .filter(':visible');
        }

        function syncPrice() {
            var $out = $info.find('.m-satb__price').empty();
            priceSources().each(function () {
                var $c = $(this).clone();
                $c.find('input, .visually-hidden').remove();
                $c.removeAttr('id').find('[id]').removeAttr('id');
                $out.append($c, ' ');
            });
        }
        syncPrice();

        // theme.js rewrites the variant price, compare-at and savings on
        // variant change.
        if ('MutationObserver' in window) {
            var priceFrame = 0;
            var priceMo = new MutationObserver(function () {
                if (priceFrame) { return; }
                priceFrame = requestAnimationFrame(function () { priceFrame = 0; syncPrice(); });
            });
            $meta.children('[class*="product__price-wrap-"], .product__price, .product__price-savings, .full_price')
                .each(function () {
                    priceMo.observe(this, {
                        attributes: true, attributeFilter: ['class'],
                        childList: true, characterData: true, subtree: true
                    });
                });
        }

        // How far bottom-anchored widgets must lift to clear the strip too.
        // Kept for the whole time the bar shows, not just while the strip is
        // open: right after docking the real info sits directly above the
        // bar, which is exactly where an un-lifted teaser would land.
        var infoH = Math.ceil($info[0].scrollHeight);
        document.documentElement.style.setProperty('--m-satb-info-h', infoH + 'px');

        // Dock on the lowest real info element (the price); fall back to the
        // title if there is no visible price.
        var dockTarget = priceSources().last()[0] ||
            $meta.find('h1.product-single__title').first()[0];

        if (dockTarget) {
            // Root = viewport minus the button row, with its top pushed far
            // above the page so anything scrolled past still counts as fully
            // inside. Ratio < 1 then only ever means "still below the band",
            // and a jump straight from far down the page back to the top
            // still crosses a threshold.
            new IntersectionObserver(function (entries) {
                $('body').toggleClass('m-satb-info-on', entries[0].intersectionRatio < 0.99);
            }, {
                threshold: [0, 0.99, 1.0],
                rootMargin: '100000px 0px -' + btnRowH + 'px 0px'
            }).observe(dockTarget);
        }

        // Grouped / Grouped-Fits use .product-option-set, Std products use
        // .variant-wrapper--button.
        function sizeTarget() {
            var $t = $('.product-option-set').first();
            if (!$t.length) { $t = $('.variant-wrapper--button').first(); }
            return $t;
        }

        // Mirror the real button's label and sold-out state. The real label
        // is whichever of its spans is rendered: .m-original-text is always
        // display:none (custom_f_a.scss), Std shows .js-choose-option, and
        // Grouped toggles .js-original-button-text-top/-bottom/-both with
        // inline display. Reading .text() off the button would concatenate
        // the hidden ones too.
        function visibleLabel() {
            var parts = [];
            $realBtn.children('span').each(function () {
                if (!this.getClientRects().length) { return; }
                var t = $.trim($(this).text());
                if (t) { parts.push(t); }
            });
            return parts.join(' ');
        }

        function sync() {
            var soldOut = $realBtn.is('[disabled]') || $realBtn.hasClass('disabled');
            var txt;
            if ($realBtn.hasClass('m-select-sz')) {
                txt = 'Select Size';
            } else if (soldOut) {
                txt = $.trim($realBtn.find('.m-original-text').text()) || visibleLabel();
            } else {
                txt = visibleLabel();
            }
            $satbLabel.text(txt || 'Add to Bag');
            $satbBtn.prop('disabled', soldOut);
        }
        sync();

        // The theme rewrites the button's classes, text and span visibility
        // (inline display) as variants change. Coalesced: visibleLabel()
        // reads layout, and Grouped toggles several spans in one go.
        if ('MutationObserver' in window) {
            var syncFrame = 0;
            new MutationObserver(function () {
                if (syncFrame) { return; }
                syncFrame = requestAnimationFrame(function () { syncFrame = 0; sync(); });
            }).observe($realBtn[0], {
                attributes: true,
                childList: true,
                characterData: true,
                subtree: true,
                attributeFilter: ['class', 'disabled', 'style']
            });
        }

        new IntersectionObserver(function (entries) {
            var visible = entries[0].isIntersecting;
            $('body').toggleClass('m-satb-on', !visible);
            $satb.attr('aria-hidden', visible ? 'true' : 'false');
            syncAttentive();
        }, { threshold: 1.0 }).observe($realBtn[0]);

        // Attentive's "GET 15% OFF" tab is a fixed iframe pinned bottom-left
        // (#attentive_creative inside #attentive_overlay) at z-index
        // 2147483647, so it lands on top of the bar and covers the start of
        // the label. Lift it with a transform rather than rewriting its
        // bottom: Attentive's own positioning stays intact and undoing it is
        // a single property.
        //
        // Only while it is tab-sized. Attentive expands that same iframe into
        // the full-screen signup modal, and the offset is dropped the moment
        // it does, so the modal renders exactly as it always has.
        function syncAttentive() {
            var ifr = document.getElementById('attentive_creative');
            if (!ifr) { return; }
            var isTab = ifr.getBoundingClientRect().height < 120;
            var want = (isTab && $('body').hasClass('m-satb-on')) ? 'translateY(-' + (70 + infoH) + 'px)' : '';
            // Only write on a real change - Attentive rewrites this style
            // attribute itself, and the observer below would otherwise loop.
            if (ifr.style.getPropertyValue('transform') === want) { return; }
            if (want) {
                ifr.style.setProperty('transform', want, 'important');
            } else {
                ifr.style.removeProperty('transform');
            }
        }

        // Coalesce into one frame: Attentive rewrites the style attribute in
        // bursts, and syncAttentive reads getBoundingClientRect, which forces
        // synchronous layout on a very large DOM.
        var satbFrame = 0;
        function syncAttentiveSoon() {
            if (satbFrame) { return; }
            satbFrame = requestAnimationFrame(function () {
                satbFrame = 0;
                syncAttentive();
            });
        }

        // The tag injects the tab a few seconds after load, so wait for it.
        (function watchAttentive(tries) {
            var ov = document.getElementById('attentive_overlay');
            if (!ov) {
                if (tries > 0) {
                    setTimeout(function () { watchAttentive(tries - 1); }, 1000);
                }
                return;
            }
            syncAttentive();
            if ('MutationObserver' in window) {
                new MutationObserver(syncAttentiveSoon).observe(ov, {
                    childList: true,
                    subtree: true,
                    attributes: true,
                    attributeFilter: ['style']
                });
            }
        }(20));

        // Deliberately NOT bound to resize: on iOS the URL bar collapsing
        // during the first upward swipe fires resize mid-gesture, and this
        // handler forces a layout. Orientation changes are rare enough to be
        // safe, and Attentive's own mutations are covered by the observer.
        $(window).on('orientationchange', syncAttentiveSoon);

        $satbBtn.on('click', function (e) {
            e.preventDefault();

            // Nothing selected yet: bring the sizes into view rather than
            // submitting, which is the whole point of the pattern.
            if ($realBtn.hasClass('m-select-sz')) {
                var $t = sizeTarget();
                if ($t.length) {
                    $t[0].scrollIntoView({ behavior: 'smooth', block: 'center' });
                    // Restart the highlight even on a repeat tap: drop the
                    // class, force a reflow, re-add.
                    $t.removeClass('m-satb-hl');
                    void $t[0].offsetWidth;
                    $t.addClass('m-satb-hl');
                    setTimeout(function () { $t.removeClass('m-satb-hl'); }, 1500);
                }
                // Std products have their own "Please select a size" live-region
                // message bound to this click; other types do not bind it, and
                // clicking through would submit.
                if ($('body').hasClass('m-vbb-product')) {
                    $realBtn.trigger('click');
                } else if ($realBtn.find('.product-opt__wrapper').length) {
                    // Grouped / Grouped-Fits / Sold-As-Set: wrapper handler validates and shows the message
                    $realBtn.find('.product-opt__wrapper').trigger('click');
                }
                return;
            }

            // Pre-open the sidecart so it is not waiting on the add AJAX.
            $('body').trigger('added.ajaxProduct');

            // Grouped / Grouped-Fits add through the wrapper inside the button;
            // everything else submits the button itself.
            var $wrapper = $realBtn.find('.product-opt__wrapper');
            if ($wrapper.length) {
                $wrapper.trigger('click');
            } else {
                $realBtn.trigger('click');
            }
        });

        // Keep the bar clear of drawers, overlays and the size chart.
        $(document).on('click', '.js-drawer-open-nav, .js-drawer-open-right, .overlay-trigger', function () {
            $('body').addClass('m-satb-hold');
        });
        $(document).on('click', '.js-drawer-close, .overlay-close, .m-close-options, .product-form__popup-close', function () {
            $('body').removeClass('m-satb-hold');
        });
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
    } else {
        init();
    }
}());
